module.exports = __webpack_public_path__ + "img/hc-icon06.401956b4.svg";